module.exports = __webpack_public_path__ + "static/img/2.197ea57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/oppo/2.png
// module id = wvNA
// module chunks = 0